import { render, staticRenderFns } from "./category_res.vue?vue&type=template&id=929b255c&scoped=true&"
import script from "./category_res.vue?vue&type=script&lang=js&"
export * from "./category_res.vue?vue&type=script&lang=js&"
import style0 from "./category_res.vue?vue&type=style&index=0&id=929b255c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "929b255c",
  null
  
)

export default component.exports